// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-file {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.upload-btn-wrapper {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px 10px;
}
.upload-btn-wrapper label {
  display: flex;
}
.upload-btn-wrapper .icon-not-send {
  font-size: 26px;
  cursor: pointer;
}

ion-title {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.btn-publish {
  width: 120px !important;
  height: 45px;
  font-family: var(--font);
  font-weight: 700;
  font-size: 1em;
  text-transform: none;
  display: flex;
  border-radius: 28px;
}
.btn-publish > ion-icon {
  margin: auto 1px auto auto;
}
.btn-publish > span {
  margin: auto;
}

.background {
  padding-top: 5px;
}

#textArea {
  width: 100%;
  height: auto;
}

.post-user-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  border: 1px solid;
  border-color: rgba(0, 0, 0, 0.06);
}

.user-comment-picture {
  height: 38px;
  width: 38px;
  border-radius: 50%;
}

.user-name {
  font-weight: 600;
}

.date {
  font-size: 0.8em;
  font-weight: 300;
}

.post-description {
  margin: 6px 16px 15px;
  font-family: var(--font);
}

.img-post {
  width: 100%;
  max-height: 200px;
  object-fit: cover;
}

.post-n-comment-div {
  margin-left: 17px;
  margin-top: 5px;
  margin-bottom: 10px;
}

.delete-btn {
  float: right;
  padding-right: 10px;
}

.align-texts-like {
  width: 100%;
  display: inline-flex;
  align-items: center;
}

.icon-like {
  font-size: 1.4em;
}

.icon-comment {
  margin-right: 3px;
  font-size: 1.4em;
}

@media only screen and (min-width: 320px) {
  .normal-text {
    font-size: 0.96em;
  }
}
.total-likes {
  margin-left: 8px;
}

.input-comment {
  resize: none;
}

.pos-btn-send {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-col-size {
  display: flex;
  align-items: center;
}

.btn-send-msg {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  float: left;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-send {
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.view-more {
  text-align: center;
}

.icon-fixed {
  float: right;
}

#icon_fixed {
  width: 17px;
  height: 17px;
}

.icon-trash {
  float: right;
}

.color-trash {
  color: #c91f1f;
}

.st0 {
  fill: #808080;
}

.btn-attach-picture {
  font-size: 22px;
}

.display-flex-align {
  display: flex;
  align-items: center;
}

.float-right {
  float: right;
}

.float-left {
  float: left;
}

.separator-vertical {
  width: 1px;
  background: var(--text-color-2nd-login-desktop);
  margin-right: 6px;
  opacity: 0.09;
}

#myImg {
  width: 45px;
  height: 45px;
  border-radius: 6px;
  object-fit: cover;
}

.description-input {
  padding-top: 10px;
  height: 45%;
  resize: none;
  background: #ffffff;
  border-bottom: 1px solid #ECEAF3;
  --placehoder-color: #9D93C2;
  font-style: var(--font);
  font-weight: 400;
}

.text-input-ios {
  margin: 0 auto;
}

.text-input-md {
  margin: 0 auto;
}

.mg-card {
  margin-top: 4px;
}

.btn-default {
  padding: 8px;
  font-size: 1em;
  border-radius: 15px;
  min-width: 100%;
}

ion-avatar {
  width: 46px;
  height: 46px;
  border: 2px solid transparent;
  padding: 1px;
  cursor: pointer;
}
ion-avatar img {
  width: 44px;
}

.profile-picture {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
  margin: 0 auto;
  background: var(--bg-color);
  padding: 10px;
}
.profile-picture .cus-picture {
  width: 16px;
  height: 16px;
  margin: auto;
  border-radius: 0;
  opacity: 0.6;
}

.name-post {
  font-family: var(--font);
  font-weight: 300;
  cursor: pointer;
}

.post-date {
  font-family: var(--font);
  font-weight: 300;
  opacity: 0.5;
}

.post-card-content {
  padding: 0;
}
.post-card-content .post-img {
  max-height: 60%;
  padding: 10px;
  display: block;
}

.align-footer-post ion-col {
  display: flex;
}
.align-footer-post ion-col .like-container {
  display: flex;
  padding-left: 9px;
}
.align-footer-post ion-col .align-texts-comment {
  display: inline-flex;
  margin-left: 8px;
}
.align-footer-post ion-col .nbr-likes-cmts {
  font-family: var(--font);
  font-weight: 300;
  font-size: 14px;
  margin: auto 0 auto 5px;
}
.align-footer-post ion-col ion-icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.social-sharing {
  float: right;
  font-size: 1.2em;
}

.header-post-item {
  border: none !important;
  padding: 0 !important;
}

.align-button-options {
  display: flex;
  justify-content: flex-end;
}

.more-options-btn {
  font-size: 1.4em;
}

.bottom-form {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}
.bottom-form a {
  margin: auto 9px auto 0;
}

ion-card {
  max-width: 600px;
  margin-top: 15px auto !important;
  width: 100%;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1), 0 2px 9px 0 rgba(0, 0, 0, 0.1);
}

.btn-more {
  --background: transparent;
  color: black;
  --box-shadow: none;
  --background-hover: rgb(0 0 0 / 0.03);
  --background-focused: rgb(0 0 0 / 0.03);
}
.btn-more ion-icon {
  transform: rotate(90deg);
  width: 1.3rem;
  height: 1.3rem;
}

.container {
  position: relative;
}
.container > .wait-content {
  position: absolute;
  top: 15px;
  left: 0;
  width: 100%;
  text-align: center;
  font-family: var(--font);
  font-weight: 600;
  font-size: 1.3rem;
}
.container ion-icon {
  height: 300px;
  width: 100%;
}
.container .text-empty-content {
  height: 70px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin: auto;
  text-align: center;
  font-family: var(--font);
}
.container .text-empty-content .title {
  font-weight: 600;
  font-size: 17px;
  margin-bottom: 10px;
}

@media screen and (min-width: 768px) {
  .container ion-icon {
    height: 440px;
  }
}
ion-fab {
  --ion-safe-area-top: 20px;
  --ion-safe-area-bottom: 22px;
  position: fixed;
  --border-width: 30px;
  --background-focused-opacity: 30px;
}

.custom-card-feed {
  border-radius: 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/feed-news/feed-news.page.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AACJ;;AAEA;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AACJ;AACI;EACI,aAAA;AACR;AAEI;EACI,eAAA;EACA,eAAA;AAAR;;AAIA;EAEI,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AAFJ;;AAOA;EACI,uBAAA;EACA,YAAA;EACA,wBAAA;EAA0B,gBAAA;EAC1B,cAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;AAHJ;AAKI;EACI,0BAAA;AAHR;AAMI;EACI,YAAA;AAJR;;AAQA;EACI,gBAAA;AALJ;;AAQA;EACI,WAAA;EACA,YAAA;AALJ;;AAQA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,iCAAA;AALJ;;AAQA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;AALJ;;AAQA;EACI,gBAAA;AALJ;;AAQA;EACI,gBAAA;EACA,gBAAA;AALJ;;AAQA;EACI,qBAAA;EAEA,wBAAA;AANJ;;AASA;EACI,WAAA;EACA,iBAAA;EACA,iBAAA;AANJ;;AAiBA;EACI,iBAAA;EACA,eAAA;EACA,mBAAA;AAdJ;;AAiBA;EACI,YAAA;EACA,mBAAA;AAdJ;;AAiBA;EACI,WAAA;EACA,oBAAA;EACA,mBAAA;AAdJ;;AAkBA;EACI,gBAAA;AAfJ;;AAkBA;EACI,iBAAA;EACA,gBAAA;AAfJ;;AAmBA;EACI;IACI,iBAAA;EAhBN;AACF;AAmBA;EACI,gBAAA;AAjBJ;;AAoBA;EACI,YAAA;AAjBJ;;AAoBA;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,mBAAA;AAjBJ;;AAoBA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjBJ;;AAoBA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAjBJ;;AAoBA;EACI,kBAAA;AAjBJ;;AAoBA;EACI,YAAA;AAjBJ;;AAoBA;EACI,WAAA;EACA,YAAA;AAjBJ;;AAoBA;EACI,YAAA;AAjBJ;;AAoBA;EACI,cAAA;AAjBJ;;AAoBA;EACI,aAAA;AAjBJ;;AAoBA;EACI,eAAA;AAjBJ;;AAoBA;EACI,aAAA;EACA,mBAAA;AAjBJ;;AAoBA;EACI,YAAA;AAjBJ;;AAoBA;EACI,WAAA;AAjBJ;;AAoBA;EACI,UAAA;EAEA,+CAAA;EACA,iBAAA;EACA,aAAA;AAlBJ;;AAqBA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAlBJ;;AAqBA;EACI,iBAAA;EAEA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;EACA,2BAAA;EACA,uBAAA;EAAyB,gBAAA;AAlB7B;;AAqBA;EACI,cAAA;AAlBJ;;AAqBA;EACI,cAAA;AAlBJ;;AAqBA;EACI,eAAA;AAlBJ;;AAqBA;EACI,YAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;AAlBJ;;AAqBA;EACI,WAAA;EACA,YAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;AAlBJ;AAoBI;EACI,WAAA;AAlBR;;AAsBA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,2BAAA;EACA,aAAA;AAnBJ;AAqBI;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;AAnBR;;AAuBA;EAGI,wBAAA;EAA0B,gBAAA;EAE1B,eAAA;AAtBJ;;AAyBA;EACI,wBAAA;EAA0B,gBAAA;EAC1B,YAAA;AArBJ;;AAwBA;EACI,UAAA;AArBJ;AAuBI;EAEI,eAAA;EACA,aAAA;EAGA,cAAA;AAxBR;;AAkCI;EACI,aAAA;AA/BR;AAiCQ;EACI,aAAA;EAEA,iBAAA;AAhCZ;AAmCQ;EAEI,oBAAA;EACA,gBAAA;AAlCZ;AAuCQ;EACI,wBAAA;EAA0B,gBAAA;EAC1B,eAAA;EACA,uBAAA;AApCZ;AAuCQ;EACI,WAAA;EACA,YAAA;EACA,eAAA;AArCZ;;AA0CA;EACI,YAAA;EACA,gBAAA;AAvCJ;;AA0CA;EACI,uBAAA;EACA,qBAAA;AAvCJ;;AA0CA;EACI,aAAA;EACA,yBAAA;AAvCJ;;AA0CA;EACI,gBAAA;AAvCJ;;AA0CA;EACI,aAAA;EACA,WAAA;EACA,yBAAA;AAvCJ;AAyCI;EACI,uBAAA;AAvCR;;AA2CA;EACI,gBAAA;EACA,gCAAA;EACA,WAAA;EACA,0EAAA;AAxCJ;;AA4CA;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,uCAAA;AAzCJ;AA2CI;EACI,wBAAA;EACA,aAAA;EACA,cAAA;AAzCR;;AA4CA;EACI,kBAAA;AAzCJ;AA0CI;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;EAA0B,gBAAA;EAC1B,iBAAA;AAvCR;AAyCI;EACI,aAAA;EACA,WAAA;AAvCR;AAyCI;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,wBAAA;AAvCR;AAwCQ;EACI,gBAAA;EACA,eAAA;EACA,mBAAA;AAtCZ;;AA0CA;EAEQ;IACI,aAAA;EAxCV;AACF;AA4CA;EACI,yBAAA;EACA,4BAAA;EACA,eAAA;EACA,oBAAA;EACA,kCAAA;AA1CJ;;AA6CA;EACI,kBAAA;AA1CJ","sourcesContent":[".input-file {\n    width: 0.1px;\n    height: 0.1px;\n    opacity: 0;\n    overflow: hidden;\n    position: absolute;\n    z-index: -1;\n}\n\n.upload-btn-wrapper {\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0px 10px;\n\n    label {\n        display: flex;\n    }\n\n    .icon-not-send {\n        font-size: 26px;\n        cursor: pointer;\n    }\n}\n\nion-title {\n    // position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    // text-align: left;\n    // text-transform: uppercase;\n}\n\n.btn-publish {\n    width: 120px !important;\n    height: 45px;\n    font-family: var(--font); font-weight: 700;;\n    font-size: 1em;\n    text-transform: none;\n    display: flex;\n    border-radius: 28px;\n\n    >ion-icon {\n        margin: auto 1px auto auto;\n    }\n\n    >span {\n        margin: auto;\n    }\n}\n\n.background {\n    padding-top: 5px;\n}\n\n#textArea {\n    width: 100%;\n    height: auto;\n}\n\n.post-user-avatar {\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    border: 1px solid;\n    border-color: rgba(0, 0, 0, 0.06);\n}\n\n.user-comment-picture {\n    height: 38px;\n    width: 38px;\n    border-radius: 50%;\n}\n\n.user-name {\n    font-weight: 600;\n}\n\n.date {\n    font-size: 0.8em;\n    font-weight: 300;\n}\n\n.post-description {\n    margin: 6px 16px 15px;\n    // font-family: var(--font); font-weight: 400;;\n    font-family: var(--font);\n}\n\n.img-post {\n    width: 100%;\n    max-height: 200px;\n    object-fit: cover;\n}\n\n// .divider {\n// margin-top: 6px;\n// margin-bottom: 6px;\n// width: 100%;\n// height: 1px;\n// background: rgba(0, 0, 0, 0.04);\n// }\n\n.post-n-comment-div {\n    margin-left: 17px;\n    margin-top: 5px;\n    margin-bottom: 10px;\n}\n\n.delete-btn {\n    float: right;\n    padding-right: 10px;\n}\n\n.align-texts-like {\n    width: 100%;\n    display: inline-flex;\n    align-items: center;\n}\n\n\n.icon-like {\n    font-size: 1.4em;\n}\n\n.icon-comment {\n    margin-right: 3px;\n    font-size: 1.4em;\n}\n\n\n@media only screen and (min-width: 320px) {\n    .normal-text {\n        font-size: 0.96em;\n    }\n}\n\n.total-likes {\n    margin-left: 8px;\n}\n\n.input-comment {\n    resize: none;\n}\n\n.pos-btn-send {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.custom-col-size {\n    display: flex;\n    align-items: center;\n}\n\n.btn-send-msg {\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    float: left;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.icon-send {\n    width: 20px;\n    height: 20px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.view-more {\n    text-align: center;\n}\n\n.icon-fixed {\n    float: right;\n}\n\n#icon_fixed {\n    width: 17px;\n    height: 17px;\n}\n\n.icon-trash {\n    float: right;\n}\n\n.color-trash {\n    color: #c91f1f;\n}\n\n.st0 {\n    fill: #808080;\n}\n\n.btn-attach-picture {\n    font-size: 22px; // color: #000000;\n}\n\n.display-flex-align {\n    display: flex;\n    align-items: center;\n}\n\n.float-right {\n    float: right;\n}\n\n.float-left {\n    float: left;\n}\n\n.separator-vertical {\n    width: 1px;\n    // height: 55%;\n    background: var(--text-color-2nd-login-desktop);\n    margin-right: 6px;\n    opacity: 0.09;\n}\n\n#myImg {\n    width: 45px;\n    height: 45px;\n    border-radius: 6px;\n    object-fit: cover;\n}\n\n.description-input {\n    padding-top: 10px;\n    // padding-left: 100px; //\n    height: 45%;\n    resize: none;\n    background: #ffffff;\n    border-bottom: 1px solid #ECEAF3;\n    --placehoder-color: #9D93C2;\n    font-style: var(--font); font-weight: 400;;\n}\n\n.text-input-ios {\n    margin: 0 auto;\n}\n\n.text-input-md {\n    margin: 0 auto;\n}\n\n.mg-card {\n    margin-top: 4px;\n}\n\n.btn-default {\n    padding: 8px;\n    font-size: 1em;\n    border-radius: 15px;\n    min-width: 100%;\n}\n\nion-avatar {\n    width: 46px;\n    height: 46px;\n    border: 2px solid transparent;\n    padding: 1px;\n    cursor: pointer;\n\n    img {\n        width: 44px;\n    }\n}\n\n.profile-picture {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    object-fit: cover;\n    object-position: center;\n    margin: 0 auto;\n    background: var(--bg-color);\n    padding: 10px;\n\n    .cus-picture {\n        width: 16px;\n        height: 16px;\n        margin: auto;\n        border-radius: 0;\n        opacity: 0.6;\n    }\n}\n\n.name-post {\n    // margin-left: 8px;\n    // margin-bottom: 8px;\n    font-family: var(--font); font-weight: 300;;\n    ;\n    cursor: pointer;\n}\n\n.post-date {\n    font-family: var(--font); font-weight: 300;;\n    opacity: 0.5;\n}\n\n.post-card-content {\n    padding: 0;\n\n    .post-img {\n        // width: 110%;\n        max-height: 60%;\n        padding: 10px;\n        // border-radius: 8px !important; //\n        //\n        display: block;\n    }\n}\n\n.align-footer-post {\n\n    // width: 100%;\n    // height: 100%;\n    // display: inline-flex;\n    // align-items: center;\n    ion-col {\n        display: flex;\n\n        .like-container {\n            display: flex;\n            // width: 20%;\n            padding-left: 9px;\n        }\n\n        .align-texts-comment {\n            // width: 20%;\n            display: inline-flex;\n            margin-left: 8px;\n            // align-items: center;\n            // justify-content: flex-end;\n        }\n\n        .nbr-likes-cmts {\n            font-family: var(--font); font-weight: 300;;\n            font-size: 14px;\n            margin: auto 0 auto 5px;\n        }\n\n        ion-icon {\n            width: 20px;\n            height: 20px;\n            cursor: pointer;\n        }\n    }\n}\n\n.social-sharing {\n    float: right;\n    font-size: 1.2em;\n}\n\n.header-post-item {\n    border: none !important;\n    padding: 0 !important;\n}\n\n.align-button-options {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.more-options-btn {\n    font-size: 1.4em;\n}\n\n.bottom-form {\n    display: flex;\n    width: 100%;\n    justify-content: flex-end;\n\n    a {\n        margin: auto 9px auto 0;\n    }\n}\n\nion-card {\n    max-width: 600px;\n    margin-top: 15px auto !important;\n    width: 100%;\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1), 0 2px 9px 0 rgba(0, 0, 0, 0.1);\n\n}\n\n.btn-more {\n    --background: transparent;\n    color: black;\n    --box-shadow: none;\n    --background-hover: rgb(0 0 0 / 0.03);\n    --background-focused: rgb(0 0 0 / 0.03);\n\n    ion-icon {\n        transform: rotate(90deg);\n        width: 1.3rem;\n        height: 1.3rem;\n    }\n}\n.container{\n    position: relative;\n    >.wait-content{\n        position: absolute;\n        top: 15px;\n        left: 0;\n        width: 100%;\n        text-align: center;\n        font-family: var(--font); font-weight: 600;;\n        font-size: 1.3rem;\n    }\n    ion-icon{\n        height: 300px;\n        width: 100%;\n    }\n    .text-empty-content {\n        height: 70px;\n        display: flex;\n        flex-direction: column;\n        justify-content: space-around;\n        margin: auto;\n        text-align: center;\n        font-family: var(--font);\n        .title{ \n            font-weight: 600;\n            font-size: 17px;\n            margin-bottom: 10px;\n        }\n    }\n}\n@media screen and (min-width: 768px) {\n    .container{\n        ion-icon{\n            height: 440px;\n        }\n    }\n}\n\nion-fab{\n    --ion-safe-area-top: 20px;\n    --ion-safe-area-bottom: 22px;\n    position: fixed; \n    --border-width: 30px;\n    --background-focused-opacity: 30px;\n\n}\n.custom-card-feed{\n    border-radius: 0px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
